import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/joy";
import {
  ShoppingCart,
  Dashboard,
  People,
  BarChart,
  Layers,
  Settings,
  ArrowBackIos,
  ArrowForwardIos,
  ShoppingBasket,
  DeliveryDining,
  CurrencyRupeeRounded,
  CelebrationOutlined,
} from "@mui/icons-material";
import DashboardContent from "./dashboardContent";

import AdminProductManagement from "./productManagement";
import VendorManagement from "./VendorManagement";
import AdminAnalytics from "./AdminAnalytics";
import AdminFinancialManagement from "./AdminFinancialManagement";
import DeliveryStaffManagement from "./DeliveryStaffManagement";
import AdminSettings from "./AdminSettings";
import AdminOrderManagement from "./AdminOrderManagement";
import AdminCustomerManagement from "./AdminCustomerManagement";
import UserManagement from "./UserManagement";
import AdminUserManagement from "./AdminUserManagement";
import AdminDeliveryManagement from "./AdminDeliveryManagement";

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import MarketandPromotions from "./MarketingandPromotions";
import AdminProfile from "./AdminProfile";
import { useSelector } from "react-redux";
// import ProductManagement from './productManagement';
// import OrderManagement from './orderManagement';
// import CustomerMnagement from './customerManagement';
// import SettingsPage from './settings-page';

const Analytics = () => <div>Analytics Content</div>;
const Transactions = () => <div>Transactions Content</div>;
const SettingsConfiguration = () => <div>Settings & Configuration Content</div>;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map URL slugs ↔ tab names
  const tabToSlug = {
    Dashboard: "dashboard",
    "Product Management": "products",
    "Vendor Management": "vendors",
    "Order Management": "orders",
    "Customer Management": "customers",
    "Delivery Management": "delivery",
    "Financial Management": "financials",
    "Marketing & Promotions": "marketing",
    "Settings & Configuration": "settings",
    Profile: "profile",
  };
  const slugToTab = Object.fromEntries(
    Object.entries(tabToSlug).map(([k, v]) => [v, k]),
  );

  // Initialize activeTab from URL
  const getInitialTab = () => {
    const slug = location.pathname.split("/")[2]; // e.g. /dashboard/vendors → "vendors"
    return slugToTab[slug] || "Dashboard";
  };
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [sname, setSName] = useState("");
  const [showProductForm, setShowProductForm] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  // ✅ Add this block
  useEffect(() => {
    document.title = `Sthanick | ${activeTab}`;
  }, [activeTab]);

  const handleTabClick = (tab) => {
    const permissionKey = tabPermissions[tab];
    if (rolePermissions[permissionKey]) {
      setActiveTab(tab);
      navigate(`/dashboard/${tabToSlug[tab]}`); // ✅ URL updates
    }
  };

  const handleScreeName = (sname) => {
    setSName(sname);
    setActiveTab(sname);
    navigate(`/dashboard/${tabToSlug[sname] || sname.toLowerCase()}`);
  };

  const rolePermissions = useSelector((state) =>
    state.user.userdetails && state.user.userdetails.role_permissions
      ? state.user.userdetails.role_permissions
      : {},
  );
  const toggleSidebar = () => setIsCollapsed(!isCollapsed);
  const tabPermissions = {
    Dashboard: "dashboard_management",
    "Product Management": "product_management",
    "Vendor Management": "vendor_management",
    "Order Management": "order_management",
    "Customer Management": "customer_management",
    "Delivery Management": "delivery_staff_management",
    "Financial Management": "financial_management",
    "Marketing & Promotions": "marketing_and_promotions",
    // Analytics: "analytics",
    "Settings & Configuration": "system_management",
  };

  const handleBackNavigation = (value) => {
    console.log("value", value);
    setActiveTab(value);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Dashboard":
        return <DashboardContent onBackScreenName={handleScreeName} />;
      case "Product Management":
        return (
          <AdminProductManagement
            showForm={showProductForm}
            setShowForm={setShowProductForm}
            onBackScreenName={handleScreeName}
          />
        );
      //return <AdminProductManagement />;
      case "Vendor Management":
        return <VendorManagement onBackScreenName={handleScreeName} />;
      case "Customer Management":
        return <AdminCustomerManagement onBackScreenName={handleScreeName} />;
      case "Order Management":
        return <AdminOrderManagement onBackScreenName={handleScreeName} />;
      case "Delivery Management":
        // return <DeliveryStaffManagement />;
        return <AdminDeliveryManagement onBackScreenName={handleScreeName} />;
      case "Financial Management":
        return <AdminFinancialManagement onBackScreenName={handleScreeName} />;
      // case "Analytics":
      //   return <AdminAnalytics onBackScreenName={handleScreeName} />;
      case "Marketing & Promotions":
        return <MarketandPromotions onBackScreenName={handleScreeName} />;
      case "Profile":
        return <AdminProfile onBackScreenName={handleScreeName} />;
      //   case 'Customer Management':
      //     return <CustomerMnagement/>;
      // case 'Analytics':
      //   return <Analytics />;
      // case 'Transactions':
      //   return <Transactions />;
      case "Settings & Configuration":
        return <AdminSettings onBackScreenName={handleScreeName} />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Sidebar */}
      <Box
        sx={{
          width: isCollapsed ? "80px" : "250px",
          transition: "width 0.3s ease",
          backgroundColor: "#fff",
          boxShadow: 1,
          overflowY: "auto",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari/Edge
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: isCollapsed ? "center" : "space-between",
            padding: "16px",
          }}
        >
          {!isCollapsed && (
            // <Box>
            //   <Typography
            //     component="h2"
            //     variant="h6"
            //     sx={{ fontSize: "1.5rem", fontWeight: "bold" }}
            //   >
            //     <span style={{ color: "#2986cc" }}>S</span>
            //     <span style={{ color: "#f97300" }}>t</span>
            //     <span style={{ color: "#4ea8de" }}>h</span>
            //     <span style={{ color: "#2986cc" }}>a</span>
            //     <span style={{ color: "#f97300" }}>n</span>
            //     <span style={{ color: "#4ea8de" }}>i</span>
            //     <span style={{ color: "#2986cc" }}>c</span>
            //     <span style={{ color: "#f97300" }}>k</span>
            //   </Typography>
            // </Box>
            <Box
              component="img"
              src="/Sthanick.jpeg"
              alt="Sthanick"
              sx={{
                height: 40,
                width: "auto",
              }}
            />
          )}
          {/* Arrow Icon */}
          <IconButton
            onClick={toggleSidebar}
            sx={{
              position: "absolute",
              top: "50%",
              right: isCollapsed ? "-15px" : "-15px",
              transform: "translateY(-50%)",
              backgroundColor: "#fff",
              boxShadow: 1,
              "&:hover": { backgroundColor: "#f0f0f0" },
              zIndex: 1,
            }}
          >
            {isCollapsed ? <ArrowForwardIos /> : <ArrowBackIos />}
          </IconButton>
        </Box>

        {/* Sidebar List */}
        <Box
          sx={{
            flex: 1, // Allow the box to take available space
            overflowY: "auto", // Enable scrolling
            scrollbarWidth: "none", // Hide scrollbar for Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar for Chrome, Safari, and Edge
            },
          }}
        >
          <List>
            {[
              {
                text: "Dashboard",
                icon: <Dashboard />,
                permission: "dashboard_management",
              },
              {
                text: "Product Management",
                icon: <ShoppingCart />,
                permission: "product_management",
              },
              {
                text: "Vendor Management",
                icon: <ShoppingBasket />,
                permission: "vendor_management",
              },
              {
                text: "Order Management",
                icon: <ShoppingCart />,
                permission: "order_management",
              },
              {
                text: "Customer Management",
                icon: <People />,
                permission: "customer_management",
              },
              {
                text: "Delivery Management",
                icon: <DeliveryDining />,
                permission: "delivery_staff_management",
              },
              {
                text: "Financial Management",
                icon: <CurrencyRupeeRounded />,
                permission: "financial_management",
              },
              {
                text: "Marketing & Promotions",
                icon: <CelebrationOutlined />,
                permission: "marketing_and_promotions",
              },
              // {
              //   text: "Analytics",
              //   icon: <BarChart />,
              //   permission: "analytics",
              // },
              {
                text: "Settings & Configuration",
                icon: <Settings />,
                permission: "system_management",
              },
            ]
              .filter(({ permission }) => rolePermissions[permission])
              .map(({ text, icon }) => (
                <ListItem
                  button
                  key={text}
                  onClick={() => handleTabClick(text)}
                  sx={{
                    backgroundColor:
                      activeTab === text ? "#EEF2FF" : "transparent",
                    color: activeTab === text ? "#3f51b5" : "inherit",
                    "&:hover": { backgroundColor: "#EEF2FF", color: "#3f51b5" },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: activeTab === text ? "#3f51b5" : "inherit",
                      minWidth: "40px",
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  {!isCollapsed && <ListItemText primary={text} />}
                </ListItem>
              ))}
          </List>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          overflowY: "auto",
          overflowX: "hidden",
          p: { xs: 1, sm: 2 },
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default AdminDashboard;
